export default __webpack_public_path__ + "assets/payment-icons/amex.b295455d5361dd174573d9bc3e21bbf1.svg";